class ToggleMenu {
  constructor(elm) {
    this.btn = elm;
    this.wrapNav = document.querySelector('[data-nav-menu]');
    this.applyListeners();
  }

  applyListeners() {
    this.btn.addEventListener('click', this.applyClasses.bind(this));
  }

  applyClasses() {
    this.btn.classList.toggle('is-active');
    this.wrapNav.classList.toggle('header__content-wrap--is-active');
  }
}

export default {
  create(selector) {
    const elm = document.querySelector(selector);

    return new ToggleMenu(elm);
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/ToggleMenu.js